import React from 'react';

import styled from 'styled-components';

import { VIEW_CATEGORY } from 'components/View/constants';
import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';
import { canViewPricingData, hasPermissionOrAdmin } from 'helpers/permissions';
import { VIEW_PERMISSIONS } from 'permissions/views';
import { useAppSelector } from 'store/hook';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';
import { ACTOR_TYPE } from '../../../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const SidebarMenuDefaultCommunityViews = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const { views, selectedCommunity } = useAppSelector((state) => state.global);
  const showPricingData = canViewPricingData(currentUser);
  const safeViews = views ?? [];

  const communityType =
    selectedCommunity?.type === COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR
      ? ACTOR_TYPE.COMPETITOR
      : ACTOR_TYPE.COMMUNITY;

  const defaultCompanyView = safeViews.length ? safeViews.filter((view) => view.default) : [];

  const CMASummaryView = safeViews.length
    ? safeViews.find((view) => view.category === VIEW_CATEGORY.CMA_SUMMARY)
    : null;

  const canViewOverview = hasPermissionOrAdmin(currentUser, [VIEW_PERMISSIONS.OVERVIEW.VIEW]);
  const canViewCMASummary = hasPermissionOrAdmin(currentUser, [VIEW_PERMISSIONS.CMA_SUMMARY.VIEW]);

  return (
    <Container>
      <SidebarMenuCategoryHeader title={'MAIN VIEWS'} />
      {canViewOverview &&
        defaultCompanyView.map((item, index) => (
          <SidebarMenuItem
            key={item.id}
            to={`/${communityType}/${selectedCommunity?.id}/view/${item.id}`}
            label={item.category === VIEW_CATEGORY.OVERVIEW ? 'Market Overview' : item.name}
          />
        ))}
      {showPricingData && canViewCMASummary && CMASummaryView && (
        <SidebarMenuItem
          key={CMASummaryView.id}
          to={`/${communityType}/${selectedCommunity?.id}/view/${CMASummaryView.id}`}
          label={CMASummaryView.name}
        />
      )}
      {Boolean(selectedCommunity) && (
        <SidebarMenuItem to={`/${communityType}/${selectedCommunity?.id}/info`} label={'Community Data'} />
      )}
      {Boolean(selectedCommunity?.type === COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY) && (
        <SidebarMenuItem
          to={`/community/${selectedCommunity?.id}/competitor`}
          label="Competitors"
          pattern={`/community/${selectedCommunity?.id}/competitor/*`}
        />
      )}
    </Container>
  );
};

export default SidebarMenuDefaultCommunityViews;
